import { Routes, Route } from 'react-router-dom';
import Login from '../pages/Login';
import Unauthorized from '../pages/Unauthorized';
import Users from '../pages/Users';
import Admins from '../pages/Admins';
import Prompts from '../pages/Prompts';
import Dashboard from '../pages/Dashboard';
import Health from '../pages/Health';
import Credits from '../pages/Credits';
import COGS from '../pages/COGS';
import Audit from '../pages/Audit';
import Campaigns from '../pages/Campaigns';
import Coaching from '../pages/Coaching';
import NotFound from '../pages/NotFound';
import AdminRoute from '../components/auth/AdminRoute';
import AdminShell from '../components/layout/AdminShell';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes (each handles its own auth-aware redirect internally) */}
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Admin-gated */}
      <Route element={<AdminRoute />}>
        <Route element={<AdminShell />}>
          {/* Root → Dashboard for logged-in admins; unauthed → AdminRoute bounces to /login */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/health" element={<Health />} />
          <Route path="/credits" element={<Credits />} />
          <Route path="/cogs" element={<COGS />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/users" element={<Users />} />
          <Route path="/prompts" element={<Prompts />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/coaching" element={<Coaching />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
